import {
  PotentialTerminationReasonDetailDTO,
  SetTerminationDetailRequestDTO,
} from '@/api/account-controller/DTOs';
import {
  PotentialTerminationReasonDetailExplanation,
  PotentialTerminationReasonList,
} from '@/auth';

export const adaptPotentialTerminationReasonDetailsToSetTerminationDetailRequest =
  (
    potentialTerminationReasonDetails: PotentialTerminationReasonDetailExplanation,
  ): SetTerminationDetailRequestDTO['detail'] => {
    switch (potentialTerminationReasonDetails.potentialTerminationReasonId) {
      case PotentialTerminationReasonList.NoLongerContracted:
        return {
          reasonId: PotentialTerminationReasonDetailDTO.NoLongerContracted,
          denialReason: potentialTerminationReasonDetails.denialReason,
          userFirstName: potentialTerminationReasonDetails.firstName,
          userLastName: potentialTerminationReasonDetails.lastName,
          userTitle: potentialTerminationReasonDetails.title,
        };

      case PotentialTerminationReasonList.Retired:
        return {
          reasonId: PotentialTerminationReasonDetailDTO.Retired,
          retirementDate: potentialTerminationReasonDetails.retirementDate,
          details: potentialTerminationReasonDetails.details,
          userFirstName: potentialTerminationReasonDetails.firstName,
          userLastName: potentialTerminationReasonDetails.lastName,
          userTitle: potentialTerminationReasonDetails.title,
        };

      case PotentialTerminationReasonList.Deceased:
        return {
          reasonId: PotentialTerminationReasonDetailDTO.Deceased,
          userFirstName: potentialTerminationReasonDetails.firstName,
          userLastName: potentialTerminationReasonDetails.lastName,
          userTitle: potentialTerminationReasonDetails.title,
        };

      case PotentialTerminationReasonList.NoLongerAssociated: {
        return {
          reasonId: PotentialTerminationReasonDetailDTO.NoLongerAssociated,
          denialReason: potentialTerminationReasonDetails.denialReason,
          userFirstName: potentialTerminationReasonDetails.firstName,
          userLastName: potentialTerminationReasonDetails.lastName,
          userTitle: potentialTerminationReasonDetails.title,
        };
      }

      case PotentialTerminationReasonList.InvitationSentToOutdatedContact:
        return {
          reasonId:
            PotentialTerminationReasonDetailDTO.InvitationSentToOutdatedContact,
          knownNewCredentialingContact:
            potentialTerminationReasonDetails.knownNewCredentialingContact,
          newCredentialingContactDetails:
            potentialTerminationReasonDetails.newCredentialingContactDetails,
          newCredentialingContactName:
            potentialTerminationReasonDetails.newCredentialingContactName,
          newCredentialingContactPhone:
            potentialTerminationReasonDetails.newCredentialingContactPhone,
          newCredentialingContactEmail:
            potentialTerminationReasonDetails.newCredentialingContactEmail,
          userFirstName: potentialTerminationReasonDetails.firstName,
          userLastName: potentialTerminationReasonDetails.lastName,
          userTitle: potentialTerminationReasonDetails.title,
        };

      case PotentialTerminationReasonList.Other:
        return {
          reasonId: PotentialTerminationReasonDetailDTO.Other,
          denialReason: potentialTerminationReasonDetails.denialReason,
          userFirstName: potentialTerminationReasonDetails.firstName,
          userLastName: potentialTerminationReasonDetails.lastName,
          userTitle: potentialTerminationReasonDetails.title,
        };

      case PotentialTerminationReasonList.FacilityClosed:
        return {
          reasonId: PotentialTerminationReasonDetailDTO.FacilityClosed,
          retirementDate: potentialTerminationReasonDetails.closureDate,
          details: potentialTerminationReasonDetails.details,
          userFirstName: potentialTerminationReasonDetails.firstName,
          userLastName: potentialTerminationReasonDetails.lastName,
          userTitle: potentialTerminationReasonDetails.title,
        };
    }
  };
